import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { TokenService } from "../tokenManagement/token.service";
import { Notification } from "../helpers/notification";

@Injectable()
export class EligibleProfileGuard implements CanActivate {
  userLocalDetails: any; //detail from get clinet profile
  userdetails: any; //details retrieved after login
  country = "NGA";

  constructor(
    private tokenservice: TokenService,
    private router: Router,
    private notservice: Notification
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let isPermitted: boolean = true;
    this.userLocalDetails = this.tokenservice.getUserCred();
    this.userdetails = this.tokenservice.getProfileDetials();
    if (!this.userLocalDetails) {
      this.router.navigate(["/auth"]);
      isPermitted = false;
    } else {
      if (!this.userLocalDetails.clientVerificationDetails) {
        this.router.navigate(["/profile/business"]);
        this.notservice.Warning("Kindly provide your verification details");
        isPermitted = false;
      }
    }
    return isPermitted;
  }
}

@Injectable()
export class LoginGuardForProfile implements CanActivate {
  userLocalDetails: any;

  constructor(
    private tokenservice: TokenService,
    private router: Router,
    private notservice: Notification
  ) {
    // this.getLocalDetails();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let isPermitted: boolean = true;
    this.userLocalDetails = this.tokenservice.getUserCred();
    if (!this.userLocalDetails) {
      this.router.navigate(["/auth"]);
      isPermitted = false;
    } else {
      isPermitted = true;
    }
    return isPermitted;
  }
}
